import removeThousandSeparator from './removeThousandSeparator';
import replaceMinusSign from './replaceMinusSign';


function isInvalidNumber(maxNumberOfDots: number) {
    return function isInvalid(input: string): boolean {
        const matches = input.match(/\./g);
        return matches !== null && matches.length > maxNumberOfDots;
    };
}

const isInvalidFloat = isInvalidNumber(1);
const isInvalidInteger = isInvalidNumber(0);

function isValid(input: string, type: string, value: number): boolean {
    if (Number.isNaN(value)) {
        return false;
    }

    switch (type) {
        case 'float':
            return !isInvalidFloat(input);

        case 'float-negative-only':
            return !isInvalidFloat(input) && value <= 0;

        case 'float-positive-only':
            return !isInvalidFloat(input) && value >= 0;

        case 'integer':
            return !isInvalidInteger(input);

        case 'integer-negative-only':
            return !isInvalidInteger(input) && value <= 0;

        case 'integer-positive-only':
            return !isInvalidInteger(input) && value >= 0;

        default:
            return true;
    }
}

function canHaveLeadingCommaOrDot(type: string): boolean {
    return ['float', 'float-positive-only'].includes(type);
}

function hasLeadingCommaOrDot(input: string): boolean {
    return /^[,|.]$/.test(input);
}

function canHaveLeadingMinus(type: string): boolean {
    return !['float-positive-only', 'integer-positive-only'].includes(type);
}

function hasLeadingMinus(input: string): boolean {
    return input.length === 1 && input.startsWith('-');
}

export default function toNumber(input: string, type: string): { value: number; isValid: true; } | { value: ''; isValid: false; } {
    if ((canHaveLeadingCommaOrDot(type) && hasLeadingCommaOrDot(input)) ||
        (canHaveLeadingMinus(type) && hasLeadingMinus(input))
    ) {
        return { value: 0, isValid: true };
    }

    const replacedInput = replaceMinusSign(removeThousandSeparator(input))
        .replace(',', '.'); // Let's allow `,` regardless of locale.

    const value = Number(replacedInput);

    if (!isValid(replacedInput, type, value)) {
        return { value: '', isValid: false };
    }

    return { value, isValid: true };
}
